(() => {
  const root = document.querySelector('[data-asif-index]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const focusCarousel = root.querySelector('[data-index-focus-carousel]');
  const cleanupCallbacks = [];
  const listen = (target, type, handler, options) => {
    target.addEventListener(type, handler, options);
    cleanupCallbacks.push(() => target.removeEventListener(type, handler, options));
  };
  const cleanup = () => {
    cleanupCallbacks.splice(0).forEach((callback) => callback());
    root.dataset.ready = 'false';
  };

  const prepareVideos = () => {
    const videos = Array.from(root.querySelectorAll('[data-index-video]'));
    if (!videos.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection?.saveData === true;
    if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const video = entry.target;
        const source = window.matchMedia('(max-width: 699px)').matches
          ? video.dataset.mobileSrc || video.dataset.src
          : video.dataset.src;
        if (!source) return;
        video.src = source;
        video.load();
        video.addEventListener('loadeddata', () => {
          video.classList.add('is-ready');
          video.play().catch(() => {});
        }, { once: true });
        observer.unobserve(video);
      });
    }, { rootMargin: '300px 0px', threshold: 0.05 });
    videos.forEach((video) => observer.observe(video));
    cleanupCallbacks.push(() => observer.disconnect());
  };

  const prepareFocusCarousel = () => {
    if (!focusCarousel) return;
    const track = focusCarousel.querySelector('[data-index-focus-track]');
    const slides = Array.from(focusCarousel.querySelectorAll('[data-index-focus-slide]'));
    const previous = focusCarousel.querySelector('[data-index-focus-prev]');
    const next = focusCarousel.querySelector('[data-index-focus-next]');
    const current = focusCarousel.querySelector('[data-index-focus-current]');
    if (!track || slides.length < 2 || !previous || !next || !current) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let scrollFrame = 0;

    const slideLeft = (slide) => slide.offsetLeft - track.offsetLeft;
    const update = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      current.textContent = String(activeIndex + 1).padStart(2, '0');
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === slides.length - 1;
      slides.forEach((slide, slideIndex) => {
        if (slideIndex === activeIndex) slide.setAttribute('aria-current', 'true');
        else slide.removeAttribute('aria-current');
      });
    };

    const select = (index) => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: slideLeft(slides[targetIndex]),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
      update(targetIndex);
    };

    const closestIndex = () => slides.reduce((closest, slide, index) => {
      const distance = Math.abs(slideLeft(slide) - track.scrollLeft);
      return distance < closest.distance ? { index, distance } : closest;
    }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;

    previous.addEventListener('click', () => select(activeIndex - 1));
    next.addEventListener('click', () => select(activeIndex + 1));
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      select(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => update(closestIndex()));
    }, { passive: true });
    const handleResize = () => update(closestIndex());
    listen(window, 'resize', handleResize, { passive: true });
    update(0);
  };

  const handleSectionUnload = (event) => {
    if (event.target instanceof Element && event.target.contains(root)) cleanup();
  };
  listen(document, 'shopify:section:unload', handleSectionUnload);
  prepareVideos();
  prepareFocusCarousel();
})();
